import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class RenewalService {
    static loadRenewal(jobNumber, branchNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'load', [jobNumber, branchNumber], additionalHeaders);
    }

    static getRenewalProposalSummaries(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'getRenewalProposalSummaries', [], additionalHeaders);
    }

    static getRenewalProposalDetails(jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'getRenewalProposalDetails', [jobNumber], additionalHeaders);
    }

    static upgradeRenewalCoverLevel(jobNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'upgradeCoverLevel_Ext', [jobNumber], additionalHeaders);
    }

    static save(model, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'save', [model], additionalHeaders);
    }

    static updateCoveragesAndQuote(model, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'updateCoveragesAndQuote', [model], additionalHeaders);
    }

    static quote(renewalId, branchNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'quote', [renewalId, branchNumber], additionalHeaders);
    }

    static bind(jobNumber, branchNumber, paymentDetails, migratedPaymentDetails, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('renewal'),
            'bind', [jobNumber, branchNumber, paymentDetails, migratedPaymentDetails], additionalHeaders);
    }
}
